import { lineQuantity, type CartItem } from "./types";

/**
 * Gekoppelde regels. De configurator zet een `groupId` op een glasregel en op de artikelen die
 * daarbij horen: een ventilatierooster met z'n rubber, de scharnieren en de knop van een deur.
 * Dat beslag is op díe maat uitgezocht, dus het hoort het glas te volgen.
 *
 * Pure functies, zodat de winkelwagen-context ze alleen nog hoeft toe te passen — en ze te testen
 * zijn zonder React.
 */

/** De artikelen die aan deze regel hangen. Alleen een glasregel trekt bij-artikelen mee; een los
 *  scharnier weghalen mag zonder dat de deur verdwijnt. */
export function gekoppeldeArtikelen(items: CartItem[], id: string): CartItem[] {
  const hoofd = items.find((i) => i.id === id);
  const gid = hoofd?.kind === "glass" ? hoofd.groupId : undefined;
  if (!gid) return [];
  return items.filter((i) => i.id !== id && i.kind === "article" && i.groupId === gid);
}

/** De regel plus alles wat eraan hangt eruit. */
export function zonderRegelEnKoppeling(items: CartItem[], id: string): CartItem[] {
  const eruit = new Set([id, ...gekoppeldeArtikelen(items, id).map((i) => i.id)]);
  return items.filter((i) => !eruit.has(i.id));
}

/**
 * Aantal van een regel wijzigen. Bestel je twee dezelfde deuren, dan horen daar ook twee sets
 * beslag bij: de gekoppelde artikelen schalen mee (afgerond, minimaal 1).
 */
export function metNieuwAantal(items: CartItem[], id: string, quantity: number): CartItem[] {
  const q = Math.max(1, Math.floor(quantity) || 1);
  const hoofd = items.find((i) => i.id === id);
  const gid = hoofd?.kind === "glass" ? hoofd.groupId : undefined;
  const oud = hoofd ? lineQuantity(hoofd) : 0;
  const factor = gid && oud > 0 ? q / oud : 1;
  return items.map((i) => {
    if (i.id === id) {
      return i.kind === "glass" || i.kind === "benglas" || i.kind === "isolatieglas" || i.kind === "shower"
        ? ({ ...i, config: { ...i.config, quantity: q } } as CartItem)
        : { ...i, quantity: q };
    }
    if (gid && factor !== 1 && i.kind === "article" && i.groupId === gid) {
      return { ...i, quantity: Math.max(1, Math.round(i.quantity * factor)) };
    }
    return i;
  });
}
